const CACHED_REMOTE_IMAGE_HOSTS = new Set([
	"sebastiangrantcdn.com",
	"www.sebastiangrantcdn.com",
	"gravatar.com",
	"www.gravatar.com",
	"secure.gravatar.com",
	"0.gravatar.com",
	"1.gravatar.com",
	"2.gravatar.com",
	"i0.wp.com",
	"i1.wp.com",
	"i2.wp.com",
]);

function canUseNextImageCache(url: URL) {
	if (url.protocol !== "https:") return false;
	if (url.pathname.toLowerCase().endsWith(".svg")) return false;

	const hostname = url.hostname.toLowerCase();
	return (
		CACHED_REMOTE_IMAGE_HOSTS.has(hostname) ||
		hostname.endsWith(".gravatar.com")
	);
}

export function getCachedRemoteImageSrc(
	src?: string | null,
	{
		width = 128,
		quality = 75,
	}: {
		width?: number;
		quality?: number;
	} = {},
) {
	if (!src) return undefined;

	try {
		const url = new URL(src);
		if (!canUseNextImageCache(url)) return src;

		const cachePath = `/_next/image?url=${encodeURIComponent(
			url.toString(),
		)}&w=${width}&q=${quality}`;
		return typeof window === "undefined"
			? cachePath
			: new URL(cachePath, window.location.origin).toString();
	} catch {
		return src;
	}
}
